import { getStorage, ref, getDownloadURL } from 'firebase/storage';

const fileMaxSize = 52428800;

const defaultMessage = 'File ${1} is oversized. Max file size is 50mb';

interface UseAppFileReturn {
  validateFile: (file: File) => string[];
  downloadFile: (storageLink: string) => Promise<void>;
}

export const useAppFile = (t?: (key: string) => string): UseAppFileReturn => {
  const validateFile = (file: File): string[] => {
    const messages: string[] = [];
    if (file.size > fileMaxSize) {
      const message = t ? t('messages.error') : defaultMessage;
      messages.push(message.replace('${1}', file.name));
    }
    return messages;
  };

  const downloadFile = (storageLink: string): Promise<void> => {
    const storage = getStorage();
    const fileRef = ref(storage, storageLink);
    return getDownloadURL(fileRef).then((url) => {});
  };

  return { downloadFile, validateFile };
};
